import { type ToastProps } from "./toast";
import { KeyValueObject } from "../types/general";

export function getAnimation(visible: ToastProps["visible"], position: ToastProps["position"], theme: any): KeyValueObject {
    if (visible) {
        if (position === "top") {
            return { animation: theme.animation["enter-top"] };
        }
        return { animation: theme.animation["enter-bottom"] };
    }
    if (position === "top") {
        return { animation: theme.animation["leave-top"] };
    }
    return { animation: theme.animation["leave-bottom"] };
}

export function getBorderRadius(rounded: ToastProps["rounded"], theme: any): KeyValueObject | null {
    if (rounded === "md") {
        return { borderRadius: theme.borderRadius.DEFAULT };
    }
    if (rounded === "lg") {
        return { borderRadius: theme.borderRadius.lg };
    }
    return null;
}
